// MFA Models and Interfaces for AWS Cognito Integration

export enum MFAMethod {
  SMS = 'SMS_MFA',
  EMAIL = 'EMAIL_MFA',
  TOTP = 'SOFTWARE_TOKEN_MFA',
  WHATSAPP = 'WHATSAPP_MFA'
}

export interface MFAChallenge {
  challengeName: string; // 'SMS_MFA', 'EMAIL_MFA', 'SOFTWARE_TOKEN_MFA', 'MFA_REQUIRED'
  challengeParameters: {
    userAttributes?: Record<string, any>;
    userIdForSRP?: string;
    codeDeliveryDetails?: ChallengeCodeDetails;
  };
  session: string;
}

export interface ChallengeCodeDetails {
  destination?: string; // Phone number or email
  deliveryMedium?: string; // 'SMS' or 'EMAIL'
  attributeName?: string; // 'phone_number' or 'email'
}

export interface MFAResponse {
  success: boolean;
  message?: string;
  error?: string;
  data?: any;
}

export interface MFASetupResponse {
  sharedSecret?: string; // For TOTP
  qrCode?: string; // Data URI for QR code
  otpauth_uri?: string;
  otpauthUri?: string;
  session_token?: string;
  sessionToken?: string;
  destination_hint?: string;
  destinationHint?: string;
}

export interface UserMFASettings {
  userId: string;
  mfaEnabled: boolean;
  preferredMFAMethod: MFAMethod | null;
  enabledMethods: MFAMethod[];
  backupCodes?: string[];
  lastUpdated: Date;
  phoneNumber?: string;
  email?: string;
  totpConfigured: boolean;
}

export interface MFAVerificationRequest {
  challengeName: string;
  userAttributes: Record<string, any>;
  session: string;
  code: string; // The verification code (SMS, Email, or TOTP)
  mfaMethod: MFAMethod;
}

export interface ResendCodeRequest {
  session: string;
  challengeName: string;
  userAttributes: Record<string, any>;
}

export interface MFAEnrollmentRequest {
  userId: string;
  methods: MFAMethod[];
  phoneNumber?: string;
}

export interface MFADeviceTrackingOptions {
  rememberDevice: boolean;
  trustDevice: boolean;
}
